/* SurveyContext — provides the useFlow() value to the whole tree so any step
   component can read state/actions via useSurvey() without prop drilling. */
import * as React from 'react';
import { createContext, useContext } from 'react';
import { Flow, useFlow } from './hooks/useFlow';

const SurveyCtx = createContext<Flow | null>(null);

export function SurveyProvider({ children }: { children: React.ReactNode }) {
  const flow = useFlow();
  return <SurveyCtx.Provider value={flow}>{children}</SurveyCtx.Provider>;
}

export function useSurvey(): Flow {
  const ctx = useContext(SurveyCtx);
  if (!ctx) throw new Error('useSurvey must be used within a SurveyProvider');
  return ctx;
}
